import { InternalPartner } from '@sales-domain/product-config';

export const FULLSTORY_ORG_ID = 'ZVSN6';
export const MY_ASURION_DASHBOARD_LINK =
  'https://my.asurion.com?mxclient=asurion&mxproducttype=mobility';
export const MY_ASURION_DASHBOARD_LINK_TEXT = 'Access your plan benefits';

// Special Product SKUs
export const HOMEPLUS_PROMO_SKU = 'HOMEPLUS1000';
export const HOMEPLUS_SKUS = ['HOMEPLUS2000', 'HOMEPLUS3000'];
export const PROMO_OVERRIDE_REFERRAL_PARTNERS = [
  '2-10hbw',
  'libertymutual',
  'viasat',
];

export const STEPS_BY_ACCOUNT_NAME: Record<string, string[]> = {
  [InternalPartner.Asurion]: [
    'personal-info',
    'pay-and-enroll',
    'confirmation',
  ],
};
export const URL_PATH_SKU_MAP: Record<string, string> = {
  'home-plus/asurion': 'HOMEPLUS3000',
  'home-plus/boomerang': 'BOOMERANGHOME',
  'home-plus/cricket': 'CRICKETHOMEPLUS',
  'home-plus/katapult': 'KATAPULTHOME',
};
export const D2C_ENROLLMENT_TYPE = 'directToConsumer';
